import { customDots } from '../../helpers/slick';

const handler = ( $ ) => {
	const $imageCarousel = $( '.image-carousel__list' );

	if ( $imageCarousel.length == 0 ) {
		return;
	}

	const slickInit = ( _, el ) => {
		const $_imageCarousel = $( el );
		const options = {
			infinite: false,
			arrows: false,
			dots: true,
			slideToShow: 1,
			touchThreshold: 10,
			speed: 150,
		};

		if ( $( '.image-carousel__item', $_imageCarousel ).length == 1 ) {
			options.dots = false;
		}

		$_imageCarousel.slick( options );
	};

	$imageCarousel.on( 'init', customDots );
	$imageCarousel.each( slickInit );
};

( ( $ ) => {
	$( handler );
} )( jQuery );
